// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-7755460a]{text-decoration:none;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;color:#000}a[data-v-7755460a]:hover{color:var(--jempolku)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
